import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  acceptInvitation,
  declineInvitation,
  getgame,
  getGameFromSlug,
  getGameFromToken,
  getInvitationFromToken,
  getLeaderBoard,
  passwordCheck,
  updateInvitationStatus,
  joingame,
  updatePhoneNumber,
  getCountries
} from "../../api/user";
import { BASE_URL } from "../../config/api";
import Default from "./Default.svg";
import Medal from "./Medal.svg";
import crown from "./crown.png";
import Invitation from "./Invitation";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Password from "./Password";
import CryptoJS from "crypto-js";
import { Link } from 'react-router-dom';
import ProcessingButton from "../../components/Skeleton/ProcessingButton";
import {
  SkeletonBlock,
  SkeletonText,
  SkeletonStat,
} from "../../components/Skeleton/Skeleton";

// `onJoined` is supplied by LeagueEntry: once this screen turns a visitor into a
// member, the entry gate re-resolves and swaps in the league's Home. Without it
// the new member would sit on this pre-revamp page behind a "Let's Go!" step.
const DetailGame = ({ onJoined }) => {
  const [joining, setJoining] = useState(false);
  const [game, setGameData] = useState(null); // Initialize as null
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const { slug } = useParams();
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isTokenLoading, setIsTokenLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [isAccepted, setIsAccepted] = useState(false);
  const [status, setStatus] = useState("");
  const location = useLocation();
  const { viewMode } = location.state || { viewMode: "default" };
  const urlParams = new URLSearchParams(window.location.search);
  const tokenValue = urlParams.get("token");
  const isFetched = useRef(false); // Prevent double-fetching
  const [passErrorMessage, setPasErrorMessage] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [country_of_origin,set_country_of_origin] = useState("");
  const [countries, setCountries] = useState([]);
  let user_id = localStorage.getItem("user_id");
  const [message, setMessage] = useState("");
  const userInfo = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
  const [phone, setPhone] = useState(userInfo.phone || "");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storedPhone, setStoredPhone] = useState("");
  const [resolveModal, setResolveModal] = useState(null);
  const [error, setError] = useState("");


  // Function to validate phone number
  // const validatePhone = (phone) => {
  //   const phoneRegex = /^\d{15}$/; // US 10-digit number (excluding invalid patterns)
  //   return phoneRegex.test(phone);
  // };

const validatePhone = (phone) => {
  const phoneRegex = /^[\d\s\-()+]*$/; // Digits, spaces, dashes, parentheses, plus
  return phoneRegex.test(phone);
};



const handlePhoneChange = (e) => {
  const value = e.target.value;
  // Allow only digits, spaces, -, (, ), +
  const cleanedValue = value.replace(/[^\d\s\-()+]/g, "");
  setPhone(cleanedValue); // Save cleaned value
  setError(""); // Clear error on change
};


    // Handle confirm button click
  const handleConfirm = () => {
    if (!validatePhone(phone)) {
      setError("Please enter a valid phone number.");
      return;
    }
    handleSave();
  };


  //Password
  const [isPasswordModalVisible, setPasswordModalVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false); // Modal state
  const [modalResponseHandler, setModalResponseHandler] = useState(null);

  // const showPasswordModal = () => setIsPasswordModalOpen(true);

  useEffect(() => {
  const storedUserInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : {};

  setStoredPhone(storedUserInfo.phone || ""); // Sync with localStorage
  set_country_of_origin(storedUserInfo.country_of_origin);
}, []); // Run only on mount


  const showPasswordModal = () => {
    return new Promise((resolve) => {
      // Open the modal
      setIsPasswordModalOpen(true);

      // Store a handler to resolve the promise when the modal closes
      const handleModalClose = (response) => {
        if (response.success) {
          setIsPasswordModalOpen(false); // Close the modal only on success
        }
        resolve(response); // Resolve the promise with the response
      };

      // Make the handler accessible in the modal
      setModalResponseHandler(() => handleModalClose);
    });
  };

  const medal = Medal;

  const [winner, setWinner] = useState(null);

  const fetchLeaderBoard = async () => {
    try {
      const response = await getLeaderBoard(game.id);
      if (response?.data?.status === 200) {
        const leaderBoardData = response.data.data.data;
        if (leaderBoardData && leaderBoardData.length > 0) {
          setWinner(leaderBoardData[0]); // Set the first object as the winner
        }
      } else {
        console.error("Failed to fetch leaderboard data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (game?.id) {
      fetchLeaderBoard();
    }
  }, [game?.id]);

  const fetchGame = async (slug) => {
    try {
      // if (isFetched.current) return;
      // isFetched.current = true;
      // Check if tokenValue is null or not
      if (tokenValue === null) {
        // tokenValue is null, call the first API
        try {
          const response = await getGameFromSlug({ slug });

          const gameData = response?.data?.data;

          if (gameData) {
            setGameData(gameData);
            setErrorMessage(""); // Clear error if game data is found
          } else {
            setErrorMessage("League not found"); // Set error if game data is missing
            navigate("/contest");
          }
        } catch (error) {
          console.error("Error fetching league data without token:", error);

          // Check if the error response status is 403 (Forbidden)
          if (error.response && error.response.status === 403) {
            toast.error("You are not a member of this league.");
            navigate("/contest");
          } else {
            setErrorMessage(
              "Error fetching League data. Please try again later."
            );
          }
        }
      } else {
        // tokenValue is not null, call the second API
        try {
          // Call the API with the token
          const responseWithToken = await getGameFromToken({
            slug,
            token: tokenValue,
          });

          const gameDataWithToken = responseWithToken?.data?.data;

          if (gameDataWithToken) {
            setGameData(gameDataWithToken);
            setErrorMessage(""); // Clear error if game data is found
          } else {
            // setErrorMessage("League not found with token"); // Set error if game data is missing
            // navigate("/contest");
          }
        } catch (error) {
          console.error("Error fetching League data with token:", error);

          // Check if the error response status is 403 (Forbidden)
          if (error.response && error.response.status === 403) {
            console.log("in if");
            toast.error("You are not a member of this game.");
            navigate("/contest");
          } else {
            setErrorMessage(
              "Error fetching league data with token. Please try again later."
            );
          }
        }
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setErrorMessage("An unexpected error occurred. Please try again later.");
    }
  };

  const verifyToken = async (token) => {
    try {
      const response = await getInvitationFromToken({ token });
      const tokenData = response?.data?.data;

      // Retrieve user info from local storage
      const userInfoString = localStorage.getItem("userInfo");
      const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
      // Check if tokenData.email matches userInfo.email
      if (userInfo && tokenData.email === userInfo.email) {
        const tokenExpiryDate = new Date(tokenData.expires_at);
        const currentDate = new Date();

        if (currentDate <= tokenExpiryDate) {
          setIsTokenValid(true);
          setStatus(tokenData.status);
        } else {
          setIsTokenValid(false);
          setStatus("");
        }
      } else {
        // Navigate to /contest if emails don't match
        //toast.error("Unauthorized access. Redirecting to contest page.");
        navigate(`/contest/${slug}`);
      }
    } catch (error) {
      console.error("Error verifying token:", error);
      setIsTokenValid(false);
    } finally {
      setIsTokenLoading(false);
    }
  };

  const updateInvitationStatu = async (token) => {
    try {
      const response = await updateInvitationStatus({ token });

      const invitationData = response?.data?.data;

      if (invitationData) {
        return invitationData;
      } else {
        setErrorMessage("Game not found"); // Set error if game data is missing
        navigate("/contest");
      }
    } catch (error) {
      console.error("Error fetching game:", error);

      setErrorMessage("Error fetching game data. Please try again later.");
    }
  };

  useEffect(() => {
    if (tokenValue) {
      setHasToken(true);
      setToken(tokenValue);
      verifyToken(tokenValue);
    } else {
      setIsTokenLoading(false); // No token to verify, stop loading
    }
  }, []);

  const handleAccept = async () => {
    if (game.game_type === "private") {
      const response = await showPasswordModal();
      console.log("Modal Response:", response);

      if (response.success) {
        console.log("Password validated successfully!");
        // alert("done");

        // Perform actions after successful validation
      } else {
        console.log("Modal closed or password validation failed.");
        // alert("failed");
        return;

        // Handle failure or cancellation
      }
    }

    const game_id = game.id;

    try {
      // Update invitation status
      const response = await updateInvitationStatu(token);
      const invitationData = response;

      if (invitationData) {
        // Prepare the body for the accept invitation request
        const body = {
          game_id: game_id,
          invitation_id: invitationData.id, // Assuming 'id' is the invitation ID
        };

        // Accept invitation
        const acceptResponse = await acceptInvitation(body);
        const gameMemberData = acceptResponse?.data?.data;

        // Check if status is 200 and show success toast
        if (acceptResponse?.data?.status === 200) {
          toast.success("You are now member of this League");
          setIsAccepted(true);
          setStatus("accepted");
          if (slug) {
            await fetchGame(slug); // Ensure `slug` is defined
          }
        } else {
          toast.error("Failed to accept the invitation. Please try again.");
        }

        console.log(gameMemberData); // Optional: Log the response data
      }
    } catch (error) {
      console.error("Error in handleAccept:", error);
      toast.error("Failed to accept the invitation. Please try again.");
    }
  };

  const handlePasswordSubmit = async () => {
    const result = await validatePasswordAndNavigate();
    if (result.success) {
      modalResponseHandler(result); // Close the modal if successful
    } else {
      setPasErrorMessage("Incorrect password. Please try again.");

      // Modal remains open for failure
    }
  };

  const handleDecline = async () => {
    try {
      // Update invitation status
      const response = await declineInvitation({ token });
      const invitationData = response;

      if (invitationData) {
        // Prepare the body for the accept invitation request

        // Check if status is 200 and show success toast
        if (invitationData?.data?.status === 200) {
          toast.info("You decline a invitation of a Game");
          setStatus("declined");
        } else {
          toast.error("Failed to accept the invitation. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error in handleAccept:", error);
      toast.error("Failed to accept the invitation. Please try again.");
    }
  };

  // Close password modal
  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
    setPassword(""); // Clear the password field when closing modal
    setPasErrorMessage(""); // Clear error message
  };

  // Handle game start click and password validation
  const handleGameStartClick = () => {
    if (game.game_type === "private") {
      // showPasswordModal(); // Show modal if game type is private
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("game_type", game.game_type);
      // navigate(`/${game.vanity_url}/buysell`, { state: { viewMode: true } });
      navigate(`/${game.vanity_url}/feeds`, { state: { viewMode: true } })
    } else {
      // For public games, navigate directly without password validation
      localStorage.setItem("game_type", game.game_type);
      // navigate(`/${slug}/buysell`, {
      //   state: { viewMode: true },
      // });
            navigate(`/${slug}/feeds`, {
        state: { viewMode: true },
      });
    }
  };

  const validatePasswordAndNavigate = async () => {
    if (password.trim() === "") {
      setPasErrorMessage("Please enter the password.");
      return { success: false };
    }

    try {
      const response = await passwordCheck({ gameId: game.id, password });
      console.log(response, "pwd try response");

      if (response?.data?.success) {
        // setIsAuthenticated(true);
        // localStorage.setItem("isAuthenticated", true);
        // localStorage.setItem("game_type", game.game_type);
        // navigate(`/${game.vanity_url}/buysell`, { state: { viewMode: true } });
        closePasswordModal(); // Close the modal
        return { success: true }; // Validation succeeded
      } else {
        setPasErrorMessage(
          response?.data?.message || "Incorrect password. Please try again."
        );
        return { success: false }; // Validation failed
      }
    } catch (error) {
      console.error("Error validating password:", error);
      setPasErrorMessage("Incorrect password. Please try again.");
      return { success: false }; // Validation failed
    }
  };

  useEffect(() => {
    if (slug) {
      fetchGame(slug); // Fetch game details regardless of token presence
    }
  }, [slug]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries(); // Your API call function

        if (response.data && response.data.success) {
          setCountries(response.data.data); // Store country list
        } else {
          console.error("Failed to fetch countries:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [])

  // Prepare final list based on the logic
  const getFinalCountryList = () => {
    if (!countries.length) return [];

    const selectedCountry = countries.find(
      (c) => c.id === parseInt(country_of_origin)
    );
    const usCountry = countries.find((c) => c.code === "US");

    // Filter out selected country and US from the main list
    let otherCountries = countries.filter(
      (c) =>
        c.id !== (selectedCountry?.id || null) && c.code !== (usCountry?.code || null)
    );

    let finalList = [];

    if (selectedCountry) {
      // If a country is selected, add it on top
      finalList.push(selectedCountry);
    }

    if (usCountry && (!selectedCountry || usCountry.id !== selectedCountry.id)) {
      // Add US if it's not already the selected country
      finalList.push(usCountry);
    }

    // Add remaining countries
    finalList = [...finalList, ...otherCountries];

    return finalList;
  };

  const finalCountryList = getFinalCountryList();
  if (isTokenLoading) {
    return <div>Loading token verification...</div>;
  }

  if (errorMessage) {
    return <div className="m-24 mb-11">{errorMessage}</div>;
  }

  // Check if the game data has been loaded before accessing its properties
  if (!game) {
    // League page initial load: cover, title and detail lines as primitives, so
    // the page has its real shape before the data lands. No spinner, no text.
    return (
      <div className="p-4 md:p-8 max-w-4xl mx-auto" aria-busy="true" aria-label="League loading">
        <SkeletonBlock height={200} rounded="rounded-xl" />
        <SkeletonBlock height={24} width="52%" className="mt-6" />
        <SkeletonText lines={3} height={12} lastLineWidth="40%" className="mt-4" />
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <SkeletonStat key={i} />
          ))}
        </div>
      </div>
    );
  }

  const imagePath =
    game.game_image && game.game_image.length > 0
      ? game.game_image[0].image
      : null;

  const filename = imagePath ? imagePath.split("/").pop() : null;

  const fullImageUrl = filename
    ? `${BASE_URL}/storage/upload/game/image/${filename}`
    : Default;

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];

  const extension = fullImageUrl.split(".").pop().toLowerCase();

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  }

  // old
  // const handleJoinGame = async () => {

  //   let gameId = game.id;
  //   try {
  //     const response = await joingame({ gameId });

  //     if (response?.data?.status === 200) {
  //       toast.success("You are now member of this game");

  //       const response = await getGameFromSlug({ slug });

  //       const gameData = response?.data?.data;

  //       if (gameData) {
  //         setGameData(gameData);
  //         setErrorMessage(""); // Clear error if game data is found
  //       } else {
  //         setErrorMessage("Game not found"); // Set error if game data is missing
  //         navigate("/contest");
  //       }

  //     } else {
  //       toast.error("Failed to accept the invitation. Please try again.");
  //     }

  //   } catch (error) {
  //     console.error("Error in handleAccept:", error);
  //     toast.error("Failed to accept the invitation. Please try again.");
  //   }
  // };

  //new



const handleSave = async () => {
  if (!phone.trim()) {
    toast.error("Phone number cannot be empty.");
    return;
  }

  if (phone.length < 10) {
    toast.error("Phone number must be at least 10 digits.");
    return;
  }

  // if (phone === storedPhone) {
  //   // toast.info("Phone number is unchanged.");
  //   setShowModal(false);
  //   if (resolveModal) resolveModal(true); // Resolve with false since nothing changed
  //   setResolveModal(null);
  //   return;
  // }

  setLoading(true);
  try {
    console.log(country_of_origin,'in try');
    const result = await updatePhoneNumber(phone,country_of_origin);

    // ✅ Update stored phone number **only after successful API call**
    setStoredPhone(phone);
    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        ...JSON.parse(localStorage.getItem("userInfo") || "{}"),
        phone,
      })
    );

    setShowModal(false);
    if (resolveModal) resolveModal(true); // ✅ Resolve promise with success
  } catch (error) {
    toast.error("Failed to update phone number. Please try again.");
  } finally {
    setLoading(false);
    setResolveModal(null); // ✅ Ensure resolver is cleared
  }
};



  const handleJoinGame = async () => {
  if (joining) return;

  if (game.is_cash_prize_league) {
  //  alert("sdfsa");

    const userConfirmed = await new Promise((resolve) => {
      setResolveModal(() => resolve); // ✅ Store resolve function
      setShowModal(true);
    });

    if (!userConfirmed) return;

  //  alert("User confirmed, proceeding...");
  }



    if (game.game_type === "private") {
      const response = await showPasswordModal();
      console.log("Modal Response:", response);

      if (response.success) {
        console.log("Password validated successfully!");
        // alert("done");

        // Perform actions after successful validation
      } else {
        console.log("Modal closed or password validation failed.");
        // alert("failed");
        return;

        // Handle failure or cancellation
      }
    }

    let gameId = game.id;
    setJoining(true);
    try {
      const response = await joingame({ gameId });

      if (response?.data?.status === 200) {
        toast.success("You are now member of this League");

        const response = await getGameFromSlug({ slug });

        const gameData = response?.data?.data;

        if (gameData) {
          setGameData(gameData);
          setErrorMessage(""); // Clear error if game data is found
          // Now a member — go straight into the league instead of stopping here.
          onJoined?.();
        } else {
          setErrorMessage("Game not found"); // Set error if game data is missing
          navigate("/contest");
        }
      } else {
        toast.error("Failed to accept the invitation. Please try again.");
      }
    } catch (error) {
      console.error("Error in handleAccept:", error);
      toast.error("Failed to accept the invitation. Please try again.");
    } finally {
      // Never leave the button stuck in `Joining`.
      setJoining(false);
    }
  };

  const getUserDisplayName = (user) => {
    // Check if full_name is available
    if (user.full_name && user.full_name.trim() !== "") {
      return user.full_name;
    }
    // If full_name is not available, check first_name
    if (user.first_name && user.first_name.trim() !== "") {
      return user.first_name;
    }
    // If first_name is not available, check last_name
    if (user.last_name && user.last_name.trim() !== "") {
      return user.last_name;
    }
    // If none are available, return email
    return user.email;
  };

  const formattedStartDate = formatDate(game.start_date);
  const formattedEndDate = formatDate(game.end_date);

  const startDate = new Date(game.start_date); // Parse the start date
  const endDate = new Date(game.end_date); // Parse the end date
  const today = new Date(); // Get today's date
  const gameStartDate = `${startDate.getFullYear()}-${String(
    startDate.getMonth() + 1
  ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;
  const gameEndDate = `${endDate.getFullYear()}-${String(
    endDate.getMonth() + 1
  ).padStart(2, "0")}-${String(endDate.getDate()).padStart(2, "0")}`;
  const todayDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;


// -----------------------------------------------------------------------------------

const checkLeagueStart = (start_date) => {
  // Get current EST time using Intl.DateTimeFormat
  const now = new Date();
  const estTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    timeStyle: 'medium',
    dateStyle: 'short',
  }).format(now);

  // Convert estTime back into a Date object
  const estDateParts = estTime.split(',')[0].split('/'); // Example "12/25/24"
  // const estCurrentDate = `20${estDateParts[2]}-${estDateParts[0]}-${estDateParts[1]}`; // Format as YYYY-MM-DD
  const estCurrentDate = `20${estDateParts[2]}-${estDateParts[0].padStart(2, '0')}-${estDateParts[1].padStart(2, '0')}`;

  // Get current hour in EST
  const estCurrentHour = new Date(estTime).getHours();

  // Parse start_date and calculate one day before
  const startDate = new Date(start_date);
  const oneDayBeforeStart = new Date(startDate);
  oneDayBeforeStart.setDate(startDate.getDate() - 1);

  // Format one day before start date as YYYY-MM-DD
  const oneDayBeforeStartDate = oneDayBeforeStart.toISOString().split("T")[0];


  if (estCurrentDate === start_date) {
    if (estCurrentHour < 8) {
      return "League will start at 8:00 AM (EST)";
    } else {
      return "Let’s Go!";
    }
  } else if (estCurrentDate === oneDayBeforeStartDate) {
    return "League will start tomorrow at 8 AM (EST)";
  }
  else if(estCurrentDate < start_date) {
    return `League will be start on ${start_date} 8:00 AM (EST)`;
  }
  else if(estCurrentDate > start_date){
    return "Let’s Go!";
  }
};




// const getLeagueEndMessage = (end_date) => {
//   // Get current EST time using Intl.DateTimeFormat
//   const now = new Date();
//   const estTime = new Intl.DateTimeFormat('en-US', {
//     timeZone: 'America/New_York',
//     timeStyle: 'medium',
//     dateStyle: 'short',
//   }).format(now);

//   // Convert estTime back into a Date object
//   const estDateParts = estTime.split(',')[0].split('/'); // Example "12/25/24"
//   const estCurrentDate = `20${estDateParts[2]}-${estDateParts[0].padStart(2, '0')}-${estDateParts[1].padStart(2, '0')}`; // Format as YYYY-MM-DD

//   // Get current hour in EST
//   const estCurrentHour = now.getHours(); // Use 'now' for getting hours in local time.

//   // Compare estCurrentDate with end_date

// // alert(estCurrentDate);
// // alert(end_date);
// alert(estCurrentHour);
//   if (estCurrentDate > end_date) {
//     return "League is finished.";
//   } else if (estCurrentDate === end_date) {
//     if (estCurrentHour >= 20) {
//       return "League is finished.";
//     }
//   }

//   // Optional: Handle other cases if needed
//   // return "Let’s Go!";
// };

const getLeagueEndMessage = (end_date) => {
  const now = new Date();

  // Get EST time components using Intl.DateTimeFormat
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    hour12: false,
  });

  const estCurrentHour = formatter.formatToParts(now).find(part => part.type === 'hour').value;

  // Format EST date
  const estDateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    dateStyle: 'short',
  });
  const estTime = estDateFormatter.format(now);
  const estDateParts = estTime.split('/');
  const estCurrentDate = `20${estDateParts[2]}-${estDateParts[0].padStart(2, '0')}-${estDateParts[1].padStart(2, '0')}`;

  // Compare estCurrentDate with end_date
  if (estCurrentDate > end_date) {
    return "League is finished.";
  } else if (estCurrentDate === end_date) {
    if (parseInt(estCurrentHour, 10) >= 20) {
      return "League is finished.";
    }
  }

  return "Let’s Go!";
};

    const Leaguemessage =checkLeagueStart(gameStartDate);

    const leagueEnd= getLeagueEndMessage(gameEndDate);

const getESTDate = () => {
  const date = new Date();
  const options = {
    timeZone: "America/New_York",
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };

  // Use Intl.DateTimeFormat to get the EST date
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  // Convert to YYYY-MM-DD format
  const [month, day, year] = formattedDate.split('/');
  return `${year}-${month}-${day}`;
};

const estDate = getESTDate();
//  alert(estDate);

// ---------------------------------------------------------------------------------

const isHoverEnabled = game?.game_members?.some(
  (member) => userInfo?.id === member.user.id
) || userInfo?.id === game.user.id; 

  return (
    <div className="md:mt-24 mt-16 mb-11 pb-32 md:pb-12">
      <h1 className="px-8 py-2 bg-[#F1F5F9] inter font-semibold text-xl hidden md:block mb-5">
        {game.title}
      </h1>
      <div className="flex max-xl:flex-wrap pt-4 md:pl-8 pl-4">
        <div className="grid xl:grid-cols-2 md:gap-12 gap-4 md:pr-12 pr-4 w-full">
          <div>
            {/* You can use the game data here */}

            {fullImageUrl && imageExtensions.includes(extension) && (
              <img
                src={fullImageUrl}
                alt={game.title}
                className="rounded-2xl mb-9 aspect-video w-full object-cover"
              />
            )}

            {fullImageUrl && videoExtensions.includes(extension) && (
              <video
                autobuffer
                autoPlay
                playsInline={true}
                webkit-playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="deny"
                disablePictureInPicture={true}
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
                loop
                muted
                style={{ maxWidth: "100%", height: "auto" }}
                className="rounded-2xl mb-9 h-80 w-full object-cover aspect-video object-center"
              >
                <source
                  src={fullImageUrl}
                  type={`video/${extension === "mov" ? "mp4" : extension}`}
                />
                Your browser does not support the video tag.
              </video>
            )}

            <div className="flex mb-3 items-center justify-between">
              <div className="flex gap-2">
                <p className="text-lg text-[#66748C]">{formattedStartDate}</p>
                <p className="text-lg text-[#66748C]"> to </p>
                <p className="text-lg text-[#66748C]">{formattedEndDate}</p>
              </div>

              {!hasToken ? (
                (() => {
                  const endDate = new Date(game.end_date.replace(" ", "T")); // Parse game.end_date
                  const startDate = new Date(game.start_date.replace(" ", "T")); // Parse game.start_date
                  const today = new Date(); // Get today's date
                  today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

                  // Check if game status is 'pending'
                  if (game.status === "pending") {
                    return "League is not Approved yet";
                  }

                  if (game.status === "cancelled") {
                    return "League is paused by admin";
                  }

                  // const showLetsGoButton =
                  //   parseInt(game.user_id) === Number(user_id);

                    // const isGameOver = gameEndDate < todayDate;

                  if (leagueEnd === "League is finished.") {
                    return (
                      <div className="text-lg font-bold">
                        League is Finished
                      </div>
                    );
                  }

                  if (Leaguemessage === "Let’s Go!" && game.isMember) {
                    return (
                      <button
                        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
                        onClick={handleGameStartClick}
                      >
                        Let's Go!
                      </button>
                    );
                  }



                  // if(Leaguemessage!== "Let’s Go!" && game.isMember){
                  //     return ( <div className="text-center">
                  //         <h1 className="text-lg font-bold">
                  //           {Leaguemessage}
                  //         </h1>
                  //       </div>
                  //     );
                  // }


                  // if(Leaguemessage!== "Let’s Go!" && !game.isMember){
                  //     return ( <div className="text-center">
                  //         <h1 className="text-lg font-bold">
                  //           {Leaguemessage}
                  //         </h1>
                  //       </div>
                  //     );
                  // }


if (game.join_after_start && !game.isMember) {
  return (
    <div className="text-center">
      <ProcessingButton
        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
        onClick={handleJoinGame}
        processing={joining}
        label="Join League"
        processingLabel="Joining"
      />
    </div>
  );
}

if(game.user.id===userInfo.id){
      return (
      <button
        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
        onClick={handleGameStartClick}
      >
        Let's Go!
      </button>
    );
}


if (game.isMember) {
  if (Leaguemessage === "Let's Go!") {
    return (
      <button
        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
        onClick={handleGameStartClick}
      >
        Let's Go!
      </button>
    );
  } else {
    return (
      <div className="text-center">
        <h1 className="text-lg font-bold">{Leaguemessage}</h1>
      </div>
    );
  }
}


                  return (
                    <>
                      {leagueEnd === "League is finished." ? ( // If game is finished
                        <div className="text-center">
                          <h1 className="text-lg font-bold">
                            League is Finished
                          </h1>
                        </div>
                      ) : game.join_after_start && !game.isMember ? ( // If joining after the start date is allowed
                        <div className="text-center">
                          <ProcessingButton
                            className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
                            onClick={handleJoinGame}
                            processing={joining}
                            label="Join League"
                            processingLabel="Joining"
                          />
                        </div>
                      ) : !game.isMember && !game.join_after_start ? ( // If user is not a member and join start toggle is off
                        gameStartDate < estDate ? ( // If the game has already started
                          <div className="text-center">
                            <p className="text-sm font-semibold text-black-700">
                              You can't join the League now.
                            </p>
                          </div>
                        ) : (
                          <ProcessingButton
                            className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
                            onClick={handleJoinGame}
                            processing={joining}
                            label="Join League"
                            processingLabel="Joining"
                          />
                        )
                      ) : null}{""}
                      {/* Default case: Render nothing */}
                    </>
                  );
                })()
              ) : (
                <>
{status === "pending" ? (
  !game.isMember && !game.join_after_start && gameStartDate < estDate ? (
    <div className="text-center">
      <p className="text-sm font-semibold text-black-700">
        You can't join the League now.
      </p>
    </div>
  ) : (
    <>
      <button
        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
        onClick={handleAccept}
      >
        Accept
      </button>
      <button
        className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
        onClick={handleDecline}
      >
        Decline
      </button>
    </>
  )
) : status === "accepted" ? (
  // <button
  //   className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
  //   onClick={handleGameStartClick}
  // >
  //   Let's Go!
  // </button>


    leagueEnd === "League is finished." ? (
      <div className="text-lg font-bold">
        League is Finished
      </div>
    ) : (
      Leaguemessage === "Let’s Go!" ? (
        <button
          className="bg-[#1D5157] py-2 px-6 text-[#ffffff] rounded-full text-sm"
          onClick={handleGameStartClick}
        >
          Let's Go!
        </button>
      ) : (
        <div className="text-center">
          <h1 className="text-lg font-bold">
            {Leaguemessage}
          </h1>
        </div>
      )
    )

) : status === "declined" ? (
  <p className="text-red-500">You have declined the game.</p>
) : null}

                </>
              )}
            </div>
            {/* Add other game details */}
            {/* <p className="text-base text-[#66748C]">{game.description}</p> */}
          </div>

          <div>
            <div className="px-8 py-6 bg-[#F1F5F9] rounded-2xl text-base text-[#66748C] h-fit gap-12">
              <h3
                className="flex items-center gap-3 text-base sm:text-lg mb-2 font-normal text-[#1C2434]"
                id="modal-title"
              >
                <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#FFDA9F]">
                  <img src={medal} />
                </div>
                Rewards
              </h3>
              {game.reward}
              </div>

              <div>
                {game.is_cash_prize_league && (
    <div className="px-8 py-6 bg-[#F1F5F9] rounded-2xl text-base text-[#66748C] h-fit gap-12 mt-4">
      <h3
        className="flex items-center gap-3 text-base sm:text-lg mb-2 font-normal text-[#1C2434]"
        id="modal-title"
      >
        <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#FFDA9F]">
          {/* <img src={medal} alt="Cash Prize" /> */}
          <img src="/ic-cash-prize.svg" alt="Cash Prize" className="h-7 w-7" />

        </div>
        Cash Prize
      </h3>
            <p className="ml-12">${game.cash_prize_amount}</p>
    </div>
  )}

            </div>


  <div className="px-8 py-6 bg-[#F1F5F9] rounded-2xl text-sm text-[#66748C]  h-fit gap-12 mt-4 leading-relaxed">
      <h3
        className="flex items-center gap-3 text-base sm:text-lg mb-2 font-normal text-[#1C2434]"
        id="modal-title"
      >
        <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#FFDA9F]">
          {/* <img src={medal} alt="Cash Prize" /> */}
          <img src="/disclaimer.png" alt="Cash Prize" className="h-6 w-6" />

        </div>
        Disclaimer
      </h3>
    {game.is_cash_prize_league ? (
      <>
      <p>
        Cash Games are skill-based contests for cash prizes organized exclusively by <b>QUSHi</b>. Only the corporate account of <b>QUSHi</b> is authorized to post skill contests for cash prizes that are guaranteed by <b>QUSHi</b>.
      </p>
          {/* <a
        href="/QUSHi%20Skilled%20Competition.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block mt-4 text-[#1D5157] underline hover:text-[#567376] transition-colors"
      >
        View Full Terms and Conditions (PDF)
      </a> */}

      <Link
  to="/contest/pdf"
  className="inline-block mt-1 text-[#1D5157] underline hover:text-[#567376] transition-colors"
>
  View Full Terms and Conditions
</Link>
      </>
    ) : (
      <p>
        In League Play, you can create private and public leagues and select rewards based on mutual agreement within the league; however, <b>QUSHi</b> is not obligated to provide these rewards.
      </p>
    )}
  </div>


            {leagueEnd === "League is finished." ? (
              <div className="text-center">
                {winner ? (
                  <div className="flex-wrap justify-center gap-3 mt-8 bg_gradient_winner rounded-2xl flex items-center py-4 px-9 bg-cover bg-no-repeat">
                    <img src="/theWinner.png" alt="theWinner" />
                    <div class="text-center text-white w-full">
                      <h4 className="md:text-2xl text-xl mb-1 font-semibold break-all">
                        {winner.full_name || winner.email}
                      </h4>
                      <p className="md:text-xl text-lg font-medium">Winner</p>
                    </div>
                  </div>
                ) : (
                  // <p className="text-gray-500">No Winner.</p>
                  <div className="flex-wrap justify-center gap-3 mt-8 bg_gradient_winner rounded-2xl flex items-center py-4 px-9 bg-cover bg-no-repeat">
                    <img src="/theWinner.png" alt="theWinner" />
                    <div class="text-center text-white w-full">
                      <h4 className="md:text-2xl text-xl mb-1 font-semibold break-all">
                        {getUserDisplayName(game.user) || "No Winner"}
                      </h4>
                      <p className="md:text-xl text-lg font-medium">Winner</p>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>

          <div className="2xl:col-span-2">
            <p
              className="text-base text-[#66748C]"
              dangerouslySetInnerHTML={{ __html: game.description }}
            />
          </div>
        </div>
        <div className="xl:w-80 w-full max-xl:mt-5 md:border-s max-md:border-t border-[#D3D3D3] md:pl-14 max-md:pt-7 md:pr-6">
          <p className="text-lg text-[#1C2434] flex gap-3 items-center mb-6">
            <p className="bg-[#D9D9D9] rounded-full w-10 h-10 flex items-center justify-center relative">
              <img
                src={crown}
                alt="Crown Icon"
                className="absolute -top-3 -left-1"
              />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  d="M12.2715 15.2799C15.5852 15.2799 18.2715 12.5936 18.2715 9.27991C18.2715 5.9662 15.5852 3.27991 12.2715 3.27991C8.95778 3.27991 6.27148 5.9662 6.27148 9.27991C6.27148 12.5936 8.95778 15.2799 12.2715 15.2799Z"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />{" "}
                <path
                  d="M3.17676 20.529C4.09885 18.933 5.42471 17.6077 7.02115 16.6863C8.61759 15.7649 10.4284 15.2799 12.2716 15.2799C14.1149 15.2799 15.9257 15.765 17.5221 16.6864C19.1185 17.6079 20.4444 18.9332 21.3664 20.5292"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />{" "}
              </svg>{" "}
            </p>
            {/* <span className="break-all">{getUserDisplayName(game.user)}</span> */}
          <span
            title={isHoverEnabled ? "View Profile" : ""}
            className={`break-all ${isHoverEnabled ? 'hover:text-[#4a5260] cursor-pointer' : ''}`}
            onClick={
              isHoverEnabled ? () => navigate(`/${slug}/profile/${game.user.id}`) : undefined
            }
          >
            {getUserDisplayName(game.user)}
          </span>

          </p>
          <div className="flex items-center justify-between gap-2">
            <p className="text-lg text-[#1C2434] flex gap-3 items-center">
              <p className="bg-[#D9D9D9] rounded-full w-10 h-10 flex items-center justify-center">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M12.2715 17.1549C14.3426 17.1549 16.0215 15.476 16.0215 13.4049C16.0215 11.3338 14.3426 9.65491 12.2715 9.65491C10.2004 9.65491 8.52148 11.3338 8.52148 13.4049C8.52148 15.476 10.2004 17.1549 12.2715 17.1549Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                  <path
                    d="M18.6465 11.1549C19.5198 11.1542 20.3813 11.3571 21.1625 11.7476C21.9437 12.1382 22.623 12.7055 23.1466 13.4045"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                  <path
                    d="M1.396 13.4047C1.91953 12.7056 2.5989 12.1383 3.38012 11.7477C4.16133 11.3572 5.02286 11.1542 5.89626 11.1549"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                  <path
                    d="M6.87451 20.5298C7.36719 19.5179 8.13444 18.6649 9.08871 18.0681C10.043 17.4713 11.1458 17.1549 12.2713 17.1549C13.3968 17.1549 14.4996 17.4713 15.4539 18.0681C16.4081 18.6648 17.1754 19.5179 17.6681 20.5298"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                  <path
                    d="M5.89641 11.1549C5.3272 11.1548 4.76976 10.9928 4.28919 10.6877C3.80863 10.3826 3.42476 9.94716 3.18243 9.43211C2.9401 8.91706 2.84929 8.34369 2.92062 7.77896C2.99195 7.21424 3.22247 6.68146 3.58527 6.24284C3.94806 5.80422 4.42815 5.47786 4.96948 5.30188C5.51081 5.1259 6.09103 5.10756 6.64239 5.24899C7.19375 5.39042 7.6935 5.6858 8.08328 6.10063C8.47305 6.51545 8.73677 7.0326 8.84363 7.5917"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                  <path
                    d="M15.6992 7.59177C15.806 7.03259 16.0697 6.51534 16.4595 6.10042C16.8493 5.6855 17.3491 5.39005 17.9005 5.24856C18.452 5.10707 19.0323 5.12539 19.5737 5.30137C20.1151 5.47736 20.5952 5.80375 20.9581 6.24242C21.3209 6.6811 21.5515 7.21395 21.6228 7.77875C21.6941 8.34356 21.6033 8.917 21.3609 9.43211C21.1185 9.94722 20.7346 10.3827 20.2539 10.6878C19.7733 10.9929 19.2157 11.1549 18.6464 11.1549"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />{" "}
                </svg>{" "}
              </p>
              Members
            </p>

            {viewMode === "creator" &&
              !hasToken &&
              game.status === "active" &&
              (() => {
                const endDate = new Date(game.end_date.replace(" ", "T")); // Parse game.end_date
                const today = new Date(); // Get today's date
                today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

                // Render button only if the endDate is today or in the future
                //if (endDate.getTime() >= today.getTime()) {
                if (gameEndDate >= todayDate) {
                  return (
                    <button
                      className="bg-[#1D5157] text-white w-18 h-6 rounded-full flex items-center justify-center p-2"
                      onClick={openModal}
                    >
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1"
                      >
                        <path
                          d="M9.746 6.114H5.912V10.002H4.382V6.114H0.566V4.728H4.382V0.821999H5.912V4.728H9.746V6.114Z"
                          fill="white"
                        />
                      </svg>{" "}
                      Invite
                    </button>
                  );
                }
                // Return null if the endDate is in the past
                return null;
              })()}
          </div>
          <ul className="list-none pl-[52px]">
{game?.game_members?.map((member) => (
  <li
    title={isHoverEnabled ? "View Profile" : ""}
    key={member.id}
    className={`text-[#66748C] text-base break-all leading-normal mt-3 ${
      isHoverEnabled ? 'cursor-pointer hover:text-[#2D3748]' : ''
    }`}
    onClick={
      isHoverEnabled
        ? () => navigate(`/${slug}/profile/${member.user.id}`)
        : undefined
    }
  >
    {member.user.user_name}
  </li>
))}


          </ul>
        </div>
        {/* Modal Component */}
        <Invitation
          isOpen={isModalOpen}
          onClose={closeModal}
          gameId={game.id}
        />
      </div>
      {/* Show password modal if the game is private */}
      {/* {isPasswordModalOpen && (
  <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="modal-content bg-white p-6 rounded-lg">
      <h2 className="text-lg font-bold mb-4">Enter League Password</h2>
      <div className="mb-4">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              validatePasswordAndNavigate();
            }
          }}
          placeholder="Enter password"
          className="border-2 p-2 w-full rounded"
        />
        {passErrorMessage && (
          <p className="text-red-500 mt-1 text-sm">{passErrorMessage}</p>
        )}
      </div>
      <div className="flex justify-between">
        <button
          onClick={async () => {
            const result = await validatePasswordAndNavigate();
            modalResponseHandler(result); // Resolve modal response with success/failure
          }}
          className="bg-[#1D5157] text-white py-2 px-6 rounded-full"
        >
          Submit
        </button>
        <button
          onClick={() => modalResponseHandler({ success: false })} // Resolve with cancel
          className="bg-gray-500 text-white py-2 px-6 rounded-full"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)} */}

      {/* {isPasswordModalOpen && (
  <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="modal-content bg-white p-6 rounded-lg">
      <h2 className="text-lg font-bold mb-4">Enter League Password</h2>
      <div className="mb-4">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={async (e) => {
            if (e.key === "Enter") {
              const result = await validatePasswordAndNavigate();
              modalResponseHandler(result); // Handle response when Enter key is pressed
            }
          }}
          placeholder="Enter password"
          className="border-2 p-2 w-full rounded"
        />
        {passErrorMessage && (
          <p className="text-red-500 mt-1 text-sm">{passErrorMessage}</p>
        )}
      </div>
      <div className="flex justify-between">
        <button
          onClick={async () => {
            const result = await validatePasswordAndNavigate();
            modalResponseHandler(result); // Resolve modal response with success/failure
          }}
          className="bg-[#1D5157] text-white py-2 px-6 rounded-full"
        >
          Submit
        </button>
        <button
          onClick={() => {
            setIsPasswordModalOpen(false); // Close the modal
            modalResponseHandler({ success: false }); // Pass failure response
          }}
          className="bg-gray-500 text-white py-2 px-6 rounded-full"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)} */}

      {isPasswordModalOpen && (
        <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="modal-content bg-white p-6 rounded-lg">
            <h2 className="text-lg font-bold mb-4">Enter League Password</h2>
            <div className="mb-4">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await handlePasswordSubmit(); // Unified handling logic
                  }
                }}
                placeholder="Enter password"
                className="border-2 p-2 w-full rounded"
              />
              {passErrorMessage && (
                <p className="text-red-500 mt-1 text-sm">{passErrorMessage}</p>
              )}
            </div>
            <div className="flex justify-between">
              <button
                onClick={async () => {
                  await handlePasswordSubmit(); // Unified handling logic
                }}
                className="bg-[#1D5157] text-white py-2 px-6 rounded-full"
              >
                Submit
              </button>
              <button
                onClick={() => {
                  setIsPasswordModalOpen(false);
                  modalResponseHandler({ success: false });
                }}
                className="bg-gray-500 text-white py-2 px-6 rounded-full"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

            {showModal && (
        <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h3 className="text-lg font-semibold mb-2">
              {phone ? "Confirm Your Details" : "Confirm Your Details"}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              We need your country and phone number to contact you for the distribution of the cash prize if you win the league.
            </p>
                  {/* <label htmlFor="country">Select Country:</label> */}
      <select
        id="country"
        value={country_of_origin}
        onChange={(e) => set_country_of_origin(e.target.value)}
      >


        <option value="">Select a Country</option>

        {finalCountryList.map((country) => (
          <option key={country.id} value={country.id}>
            {country.name}
          </option>
        ))}
      </select>

      {/* Display selected country */}
      {/* {country_of_origin && (
        <p>
          Selected Country ID: {country_of_origin} <br />
          Selected Country Name:{" "}
          {
            countries.find((c) => c.id === parseInt(country_of_origin))?.name
          }
        </p>
      )} */}

            <input
              type="tel"
              className="w-full px-3 py-2 border rounded-md text-gray-900 mt-4"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="Enter your phone number"
            />
              <p className="text-gray-400 text-sm mt-1">
              Enter your complete phone number, including the country code (e.g., +1 234 567 8901)
            </p>
             {error && <p className="text-red-500 text-sm mt-1">{error}</p>} {/* Error message */}
            <div className="flex justify-end mt-4">
              <button
                className="bg-gray-300 py-2 px-4 rounded-md mr-2"
                onClick={() => {
                  setPhone(userInfo.phone || ""); // ✅ Reset phone to initial value
                  setError("");
                  setShowModal(false);
                  if (resolveModal) resolveModal(false); // ✅ Resolve as false on cancel
                  setResolveModal(null); // ✅ Clear resolver
                }}
              >
                Cancel
              </button>
              <button
                className="bg-[#1D5157] text-white py-2 px-4 rounded-md"
                onClick={handleConfirm}
                disabled={loading}
              >
                {loading ? "Saving..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default DetailGame;